
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12752',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12752",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.481",
  "data-fetching-client": "static-1.9779",
  "foundations-components": "static-1.8171",
  "foundations-components-legacy": "static-1.1196",
  "foundations-theming": "static-1.4550",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8137",
  "hub-http-shared-msw-handlers": "static-1.10260",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11590",
  "I18n": "static-7.1639",
  "jasmine-runner": "static-1.6575",
  "marketplace-storefront-base": "static-1.12815",
  "quartz": "static-1.7182",
  "react-dlb": "static-1.81",
  "react-rhumb": "static-1.16801",
  "reactive-variable-buffer-atom": "static-1.2974",
  "reporting-testing-lib": "static-1.9988",
  "settings-ui-lib": "static-1.12638",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7357",
  "ui-addon-i18n": "static-1.11266",
  "ui-addon-react-router-dom": "static-1.9654",
  "unified-auth": "static-1.633",
  "unified-auth-core-lib": "static-1.915",
  "usage-tracker": "static-1.7466",
  "usage-tracker-core": "static-1.7316",
  "customer-data-property-utils": "static-1.8212",
  "hub-http": "static-1.6340",
  "integrations-lib": "static-1.16535",
  "marketplace-ui-common": "static-1.20165",
  "property-management-iframe": "static-1.13564",
  "quartz-config": "static-1.960",
  "quartz-core": "static-1.6401",
  "quartz-routing": "static-1.612",
  "quick-fetch": "static-1.4004",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4774",
  "ts-schema": "static-1.4168",
  "ui-universal-auth": "static-1.9119",
  "UIComponents": "static-3.8536",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3485",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3459",
  "quartz-webpack": "static-1.3406",
  "bend-plugin-quartz-routing": "static-1.260",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4440",
  "floating-ui": "static-1.58",
  "foundations-assets": "static-1.4990",
  "foundations-theming-specialty": "static-1.2266",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9540",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.37",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5428",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.489",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2197",
  "ui-fonts": "static-1.852",
  "ui-images": "static-2.1183",
  "bend-plugin-foundations-theming": "static-1.3033",
  "foundations-theming-base": "static-1.3535",
  "stylex": "static-1.35",
  "HeadJS": "static-2.771",
  "hs-test-utils-bend-plugin": "static-1.3248",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4443",
  "ai-components-ui-library": "static-1.9257",
  "ai-rendering-library": "static-1.10604",
  "chirp-fetch": "static-1.2005",
  "connections-embed-lib": "static-1.1220",
  "copilot-toolkit": "static-1.11439",
  "feedback-loader": "static-1.29525",
  "laboratory-lib": "static-3.7270",
  "marketplace-embed": "static-1.22463",
  "marketplace-ui-details": "static-1.10060",
  "marketplace-ui-reviews": "static-1.20120",
  "marketplace-ui-tracking": "static-1.14335",
  "sanitize-text": "static-1.8262",
  "ui-addon-video-player": "static-1.8821",
  "usage-tracker-multi": "static-1.5880",
  "usage-tracker-session-replay": "static-1.5152",
  "wootric-nps": "static-1.7069",
  "quartz-head": "static-1.847",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4768",
  "immer": "static-1.33",
  "immerable": "static-1.4267",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2570",
  "reporting-data": "static-1.68055",
  "cssUtils": "static-1.826",
  "flux-actions": "static-1.346",
  "HubStyle": "static-2.11897",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10324",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10479",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7456",
  "icons": "static-2.654",
  "marketplace-ui-apps-core": "static-1.18697",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4628",
  "foundations-components-test-utils": "static-1.5654",
  "quartz-i18n": "static-1.857",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.25",
  "ads-unified-auth-lib": "static-1.395",
  "google-sheets-integration-lib": "static-1.589",
  "microsoft-drive-integration-lib": "static-1.727",
  "surveymonkey-integration-lib": "static-1.45",
  "slack-ui-library": "static-1.10514",
  "fsm": "static-1.3846",
  "customer-data-objects": "static-1.7795",
  "property-translator": "static-1.5514",
  "hs-locale-management": "static-1.168",
  "frontend-preferences-client": "static-1.8044",
  "hs-promise-utils": "static-1.5710",
  "hubspot-apollo-client": "static-1.4995",
  "integrations-error-boundary-lib": "static-1.13950",
  "integrations-tracking-lib": "static-1.5723",
  "native-integrations-shared-strings": "static-1.7899",
  "reselect": "static-2.16",
  "sanitize": "static-1.4593",
  "superstore": "static-1.4876",
  "ui-shepherd-react": "static-3.10368",
  "ai-settings-ui-library": "static-1.8081",
  "hub-http-janus": "static-1.846",
  "hubspotter-http": "static-1.4737",
  "immutable-less": "static-1.4770",
  "marketplace-ui-client-types": "static-1.17572",
  "nav-meta": "static-1.29942",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18156",
  "inbound-db-properties-service-client": "static-1.3933",
  "property-management-common": "static-1.5852",
  "ui-addon-iframeable": "static-1.9184",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.545",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.857",
  "quartz-test": "static-1.857",
  "quartz-tracking": "static-1.561",
  "trellis-components": "static-1.2216",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.184",
  "bender-build-tools": "static-1.3297",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21860",
  "ContentUtils": "static-1.68713",
  "customer-data-objects-ui-components": "static-1.13146",
  "sassPrefix": "static-1.158",
  "avatar-components": "static-1.2615",
  "breeze-engine-core": "static-1.411",
  "breeze-onboarding-components": "static-1.262",
  "customer-data-filters-ui": "static-1.40211",
  "customer-data-reference-ui-components": "static-1.13291",
  "embedded-academy-lib": "static-1.14762",
  "ExportDialog": "static-6.10497",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41606",
  "reporting-snowflake": "static-1.56673",
  "reporting-ui-components": "static-2.65326",
  "reporting-visualizations": "static-1.60131",
  "trellis-theming": "static-1.1058",
  "ui-addon-teams": "static-1.21704",
  "integrations-reconnect-lib": "static-1.193",
  "magpie-lib": "static-1.5628",
  "navigation-components": "static-1.18305",
  "breeze-engine-lib": "static-1.1133",
  "magpie-types": "static-1.5088",
  "simple-logging-lib": "static-1.3166",
  "ai-studio-lib": "static-1.11967",
  "app-governance-lib": "static-1.1930",
  "developer-experience-shared-components": "static-1.10630",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8125",
  "ui-product-approvals": "static-1.28632",
  "ui-tool-access": "static-1.10266",
  "usage-based-billing-components-lib": "static-1.9440",
  "usage-tracker-anonymous": "static-1.5883",
  "usage-tracker-public": "static-1.7277",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3673",
  "persist-promise": "static-1.3817",
  "reference-resolvers": "static-1.8292",
  "ui-extensibility-client-types": "static-1.4041",
  "hubspot-apollo-cache": "static-1.454",
  "universal-page-editor-lib": "static-1.3133",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3112",
  "atom": "static-1.5192",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6097",
  "salesImages": "static-1.527",
  "batch-promise": "static-1.1660",
  "crm-component-utils": "static-1.39393",
  "crm-properties-common-lib": "static-1.6007",
  "customer-data-properties": "static-1.51977",
  "framework-data-schema-resolvers": "static-1.7011",
  "property-value-citations": "static-1.2591",
  "reference-resolvers-lite": "static-1.8214",
  "ui-business-units-lib": "static-1.9184",
  "navigation-messaging": "static-1.7632",
  "hubspotter-http-shared-msw-handlers": "static-1.10258",
  "base-ui": "static-1.14",
  "react-day-picker": "static-1.4",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4932",
  "content-icons-ui": "static-1.2260",
  "customer-data-ui-utilities": "static-1.9942",
  "conversations-skeleton-state": "static-1.7364",
  "crm-message-bus": "static-1.43296",
  "customer-data-filters-ui-msw-helpers": "static-1.22646",
  "events-data-lib": "static-1.350",
  "FormUrlGenerator": "static-2.4839",
  "framework-builder-read-service-client": "static-1.4090",
  "framework-data-schema-quick-fetch": "static-1.6916",
  "multi-account-reference-resolvers": "static-1.1099",
  "onboarding-tours": "static-1.16830",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14022",
  "academy-common-lib": "static-1.14222",
  "content-assistance-lib": "static-1.7947",
  "dashboard-lib": "static-1.82000",
  "file-manager-components": "static-1.23959",
  "getting-started-shared-tasks": "static-1.18743",
  "hubspot-prosemirror": "static-1.18583",
  "hubspot-prosemirror-plugins": "static-1.18575",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20042",
  "share-with-third-party-component-lib": "static-1.8821",
  "ui-addon-draggable": "static-3.4876",
  "ui-asset-management-lib": "static-1.11185",
  "user-context": "static-1.5226",
  "growth-payments-core": "static-1.25728",
  "reporting-plugins": "static-1.10510",
  "reporting-reports": "static-1.67733",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.843",
  "nest": "static-1.350",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10744",
  "framework-listing-lib": "static-2.29029",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30986",
  "apps-service-types": "static-1.3917",
  "oauth-service-types": "static-1.4370",
  "react-dnd-compat": "static-1.4732",
  "ui-product-approvals-common": "static-1.527",
  "onboarding-scopes": "static-1.6577",
  "onboarding-tours-client": "static-1.5044",
  "platform-infra-nav-components": "static-1.7760",
  "subscription-experience-data-types": "static-1.15067",
  "crm-record-cards-service-types": "static-1.3672",
  "location-customization-utils-lib": "static-1.9603",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6100",
  "signup-constants": "static-1.19137",
  "signup-ui-url-generator": "static-2.8174",
  "card-properties-lib": "static-1.44549",
  "commerce-subscription-lib": "static-1.37421",
  "crm-actions": "static-1.6457",
  "crm-cards-sdk": "static-1.43945",
  "customer-data-properties-shared-msw-handlers": "static-1.9587",
  "customer-data-tracking": "static-1.7004",
  "hs-resources": "static-1.292",
  "pulse": "static-1.722",
  "calling-global-api": "static-1.64920",
  "calling-internal-common": "static-1.31427",
  "calling-lifecycle-internal": "static-1.66302",
  "calling-lifecycle-messages": "static-1.58596",
  "commerce-products-lib": "static-1.10006",
  "conditional-properties-service-client": "static-1.3884",
  "crm-links": "static-1.6425",
  "crm-pipelines-api-client-types": "static-1.4223",
  "external-options-client-types": "static-1.4213",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4304",
  "meetings-icalendar-utils-lib": "static-1.750",
  "multi-currency-client-types": "static-1.3777",
  "object-builder-ui-client": "static-1.49154",
  "pipeline-validation-client-types": "static-1.4052",
  "smart-property-lib": "static-1.7848",
  "tiered-pricing": "static-1.1529",
  "ui-addon-form-validation": "static-1.11107",
  "zustand": "static-1.74",
  "fdsr-migration-layer": "static-1.130",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1173",
  "growth-data-modal": "static-1.5625",
  "growth-onboarding-confetti": "static-1.3182",
  "growth-onboarding-next-action-utils": "static-1.2260",
  "onboarding-tours-utils": "static-1.896",
  "ui-shepherd-tracker": "static-1.7749",
  "academy-service-client": "static-1.3801",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39458",
  "FileManagerLib": "static-1.39599",
  "SafeStorage": "static-1.4516",
  "video-embed": "static-1.36152",
  "ui-coaching-tips": "static-1.28890",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11660",
  "video-data-lib": "static-1.35318",
  "content-media-capture": "static-1.4876",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8559",
  "payment-link-components": "static-1.23831",
  "ui-addon-emoji-picker": "static-1.10004",
  "EmailSignatureEditor": "static-1.24639",
  "viral-links-lib": "static-1.7185",
  "data-token-picker": "static-1.16624",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.348",
  "timezone-utils": "static-2.5360",
  "seat-types-lib": "static-1.280",
  "getting-started-shared-tasks-store": "static-1.17861",
  "ui-addon-opt": "static-4.8478",
  "campaign-roi-lib": "static-1.9453",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25691",
  "framework-data-table": "static-2.12191",
  "marketing-platform-lib": "static-1.6982",
  "nudge-client-utils": "static-1.2837",
  "nudge-custom-ui-functions": "static-1.1240",
  "switchboard-lib": "static-1.341",
  "app-users-service-client": "static-1.5726",
  "app-users-service-types": "static-1.5134",
  "mini-checkout-client": "static-1.27099",
  "onboarding-utils": "static-1.5475",
  "permissions-shared-i18n-strings-fe": "static-1.2062",
  "ui-coaching-tips-shared-config": "static-1.28875",
  "edison-service-client-types": "static-1.506",
  "crm_data": "static-4.92342",
  "customer-data-sidebar": "static-2.46344",
  "enrichment-properties-lib": "static-1.16966",
  "ui-addon-draggable-compat": "static-2.4377",
  "universal-record-utils-lib": "static-1.1261",
  "commerce-billing-lib": "static-1.19478",
  "commerce-shared-components-lib": "static-1.18833",
  "commerce-tools-ui-lib": "static-1.10694",
  "crm-fe-perf": "static-1.23019",
  "event-emitter": "static-1.1066",
  "bend-plugin-pulse": "static-1.225",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31434",
  "shared-worker-versioning": "static-1.11152",
  "calling-usage-tracker": "static-1.6660",
  "voice-sms-access-library": "static-1.1449",
  "commerce-permissions": "static-1.893",
  "products-iframe-lib": "static-1.8261",
  "products-ui-components-shared-msw-handlers": "static-1.10642",
  "data-agent-kit": "static-1.398",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10343",
  "policy-lib": "static-1.6899",
  "react-tinymce": "static-1.55560",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10406",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54686",
  "tinymce-plugins": "static-1.57800",
  "tinymce-themes": "static-1.56656",
  "onboarding-data-sync-lib": "static-1.2170",
  "growth-onboarding-next-action-components": "static-1.2288",
  "user-context-client": "static-1.4697",
  "audio-components": "static-1.6103",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37110",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4653",
  "video-components": "static-1.13662",
  "outpost": "static-1.4287",
  "growth-onboarding-feedback-components": "static-1.6695",
  "content-media-composition-data-lib": "static-1.12680",
  "content-media-compositions": "static-2.16687",
  "media-bridge-lib": "static-1.19137",
  "fix-webm-duration": "static-1.24",
  "notification-sounds": "static-1.4543",
  "commerce-tours-lib": "static-1.6322",
  "growth-onboarding-reliability": "static-1.5198",
  "sales-checkout-service-client": "static-1.3710",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21890",
  "sales-email-signature-service-client": "static-1.3967",
  "ts-utils-lib": "static-1.291",
  "crm-export-dialog": "static-1.6402",
  "crm-index-associations-lib": "static-1.6558",
  "crm-view-components": "static-1.634",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7448",
  "nudge-custom-function-registry": "static-1.2594",
  "nudge-renderer-utils": "static-1.2913",
  "whisper-core-api": "static-1.6875",
  "InboxConnectUtils": "static-4.15125",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5810",
  "settings-content-modals": "static-1.46418",
  "crm_universal": "static-1.22224",
  "customer-data-email": "static-1.18251",
  "card-payment-highlight-lib": "static-1.37515",
  "card-subscription-highlight-lib": "static-1.39844",
  "commerce-contract-lib": "static-1.12638",
  "invoices-highlight-card-lib": "static-1.55116",
  "orders-highlight-card-lib": "static-1.21791",
  "products-highlight-card-lib": "static-1.18289",
  "quotes-highlight-card-lib": "static-1.72416",
  "crm-source-interpretation-lib": "static-1.5458",
  "crm-object-search-query-utilities": "static-1.9855",
  "utility-belt": "static-1.2649",
  "payments-enrollment-embed-lib": "static-1.23267",
  "stripe-embedded-components": "static-1.7725",
  "customer-data-rte": "static-1.33309",
  "cv-backend-services": "static-1.1559",
  "growth-onboarding-empty-states": "static-1.5964",
  "payments-post-enroll-local-storage-lib": "static-1.5223",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38506",
  "trials-service-types": "static-1.4000",
  "calling-orchestration-schema": "static-1.36226",
  "sales-views-client-types": "static-1.4374",
  "hub-http-contrib": "static-1.3160",
  "interframe": "static-3.4877",
  "tinymce-data": "static-1.40771",
  "ui-addon-sales-email": "static-1.5327",
  "layout-dnd-components": "static-1.12681",
  "layout-dnd-utils": "static-1.11656",
  "ui-brand-identity-lib": "static-1.15712",
  "NamespacedHubStyle": "static-2.9140",
  "meetings-connect-utils-lib": "static-1.7722",
  "social-insights-client-types": "static-1.22352",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4291",
  "checkout-sdk": "static-3.23942",
  "company-details-components": "static-1.6315",
  "payment-method-components": "static-1.6987",
  "pricing-pages-ui-components": "static-1.14727",
  "quote-checkout-service-types": "static-1.3582",
  "upgrade-catalog-service-types": "static-1.3639",
  "access-control-lib": "static-1.10553",
  "EmailComponents": "static-1.55101",
  "EmailData": "static-1.53778",
  "redux-less": "static-2.9599",
  "sequences-lib": "static-1.8246",
  "ui-gdpr-components": "static-1.10467",
  "products-ui-components": "static-1.40524",
  "accounting-integrations-ui-components": "static-1.7264",
  "invoices-ui-lib": "static-1.55132",
  "commerce-products-api": "static-1.2469",
  "invoices-iframe-lib": "static-1.57190",
  "quotes-modal-lib": "static-1.103094",
  "quotes-ui-lib": "static-1.81137",
  "stripe-connect-js": "static-1.71",
  "draft-content-plugins": "static-1.28575",
  "ContentData": "static-1.68788",
  "layout-data-lib": "static-1.9981",
  "checkout-service-types": "static-1.3883",
  "hub-http-rxjs": "static-1.812",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4054",
  "billing-payments-client-types": "static-1.4107",
  "react-performance-metrics-lib": "static-1.674",
  "pricing-pages-api": "static-1.14592",
  "ContentComponents": "static-2.71669",
  "marketing-contacts-lib": "static-1.10438",
  "marketing-email-service-types": "static-1.1986",
  "messaging-editing-lib": "static-1.46618",
  "messaging-usage-based-billing-components-lib": "static-1.1480",
  "automation-ui-source-apps": "static-1.19229",
  "automation-ui-types": "static-1.20147",
  "messaging-types-lib": "static-1.46355",
  "onboarding-settings-client": "static-1.4621",
  "sequences-client-types-lib": "static-1.8103",
  "commerce-tax-lib": "static-1.652",
  "price-books-api": "static-1.1253",
  "price-books-components": "static-1.1311",
  "property-description-translator": "static-1.3958",
  "ramp-editor": "static-1.463",
  "commerce-analytics-service-client": "static-1.3698",
  "totals-ui-components": "static-1.23920",
  "SalesContentIndexUI": "static-3.9409",
  "advanced-menus-core": "static-1.15331",
  "advanced-menus-lib": "static-1.12242",
  "ui-memberships-settings-lib": "static-1.34362",
  "segments-query-core": "static-1.1537",
  "automation-ui-ubb": "static-1.6063",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7455",
  "data-token-views": "static-1.16605",
  "forms-utils-lib": "static-1.12809",
  "payments-embed-points-lib": "static-1.13278",
  "simple-menus-core": "static-1.15330",
  "simple-menus-lib": "static-1.16847",
  "videoconference-integration-components": "static-1.7002",
  "mc-hard-limits-client-types": "static-1.15",
  "marketing-contacts-client": "static-1.7628",
  "automation-applications-service-types": "static-1.3594",
  "automation-platform-service-types": "static-1.2632",
  "ContentEditorUI": "static-2.77434",
  "short-messages-app-service-client": "static-1.4040",
  "web-interactives-components": "static-1.13975",
  "web-interactives-data": "static-1.13976",
  "messaging-shared-utils-lib": "static-1.929",
  "messaging-user-info-utils-lib": "static-1.1099",
  "email-portal-health-service-types": "static-1.1094",
  "line-items-api": "static-1.866",
  "commerce-totals-service-types": "static-1.3904",
  "FireAlarmUi": "static-1.4594",
  "sales-templates-service-types-lib": "static-1.4255",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22083",
  "automation-ui-usage-tracking": "static-1.21546",
  "data-studio-ubb": "static-1.3066",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27293",
  "collaboration-sidebar": "static-1.58196",
  "content-management-data-lib": "static-1.5618",
  "copilot-plugins": "static-1.11412",
  "cta-picker": "static-1.36713",
  "customer-agent-discovery-components-lib": "static-1.3426",
  "editor-components": "static-1.13406",
  "editor-iframe-lib": "static-1.8573",
  "error-messaging-js": "static-1.5310",
  "FormsCommonComponents": "static-1.86137",
  "pictos": "static-7.186",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10763",
  "SharedLegalStrings": "static-1.1861",
  "smart-content-core": "static-1.42767",
  "smart-content-lib": "static-1.43420",
  "social-composer-lib": "static-1.59576",
  "structured-content-lib": "static-1.25509",
  "theme-previewer-lib": "static-1.53569",
  "tinymce-copilot": "static-1.16754",
  "xray-recommendation-lib": "static-1.8059",
  "automation-ui-routing": "static-1.21504",
  "sql-reporting-client-types": "static-1.5731",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42456",
  "campaigns-utils-lib": "static-1.3310",
  "reporting-enablement": "static-1.23331",
  "chatspot-widget-iframe": "static-1.21851",
  "collaboration-sidebar-common": "static-1.2993",
  "forms-ai-lib": "static-1.4508",
  "codemirror-dlb": "static-1.58993",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6552",
  "report-customization-components": "static-1.13498",
  "data-quality-ui-library": "static-1.13342",
  "reporting-filters": "static-1.619",
  "reporting-insights-lib": "static-1.2094"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12752",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.481",
  "data-fetching-client": "/data-fetching-client/static-1.9779",
  "foundations-components": "/foundations-components/static-1.8171",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1196",
  "foundations-theming": "/foundations-theming/static-1.4550",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8137",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10260",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11590",
  "I18n": "/I18n/static-7.1639",
  "jasmine-runner": "/jasmine-runner/static-1.6575",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12815",
  "quartz": "/quartz/static-1.7182",
  "react-dlb": "/react-dlb/static-1.81",
  "react-rhumb": "/react-rhumb/static-1.16801",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2974",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9988",
  "settings-ui-lib": "/settings-ui-lib/static-1.12638",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7357",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11266",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9654",
  "unified-auth": "/unified-auth/static-1.633",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.915",
  "usage-tracker": "/usage-tracker/static-1.7466",
  "usage-tracker-core": "/usage-tracker-core/static-1.7316",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8212",
  "hub-http": "/hub-http/static-1.6340",
  "integrations-lib": "/integrations-lib/static-1.16535",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20165",
  "property-management-iframe": "/property-management-iframe/static-1.13564",
  "quartz-config": "/quartz-config/static-1.960",
  "quartz-core": "/quartz-core/static-1.6401",
  "quartz-routing": "/quartz-routing/static-1.612",
  "quick-fetch": "/quick-fetch/static-1.4004",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4774",
  "ts-schema": "/ts-schema/static-1.4168",
  "ui-universal-auth": "/ui-universal-auth/static-1.9119",
  "UIComponents": "/UIComponents/static-3.8536",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3485",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3459",
  "quartz-webpack": "/quartz-webpack/static-1.3406",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.260",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4440",
  "floating-ui": "/floating-ui/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4990",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2266",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9540",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.37",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5428",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2197",
  "ui-fonts": "/ui-fonts/static-1.852",
  "ui-images": "/ui-images/static-2.1183",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3033",
  "foundations-theming-base": "/foundations-theming-base/static-1.3535",
  "stylex": "/stylex/static-1.35",
  "HeadJS": "/HeadJS/static-2.771",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3248",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4443",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9257",
  "ai-rendering-library": "/ai-rendering-library/static-1.10604",
  "chirp-fetch": "/chirp-fetch/static-1.2005",
  "connections-embed-lib": "/connections-embed-lib/static-1.1220",
  "copilot-toolkit": "/copilot-toolkit/static-1.11439",
  "feedback-loader": "/feedback-loader/static-1.29525",
  "laboratory-lib": "/laboratory-lib/static-3.7270",
  "marketplace-embed": "/marketplace-embed/static-1.22463",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10060",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20120",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14335",
  "sanitize-text": "/sanitize-text/static-1.8262",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8821",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5880",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5152",
  "wootric-nps": "/wootric-nps/static-1.7069",
  "quartz-head": "/quartz-head/static-1.847",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4768",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4267",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2570",
  "reporting-data": "/reporting-data/static-1.68055",
  "cssUtils": "/cssUtils/static-1.826",
  "flux-actions": "/flux-actions/static-1.346",
  "HubStyle": "/HubStyle/static-2.11897",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10324",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10479",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7456",
  "icons": "/icons/static-2.654",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18697",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4628",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5654",
  "quartz-i18n": "/quartz-i18n/static-1.857",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.25",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.395",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.589",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.727",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.45",
  "slack-ui-library": "/slack-ui-library/static-1.10514",
  "fsm": "/fsm/static-1.3846",
  "customer-data-objects": "/customer-data-objects/static-1.7795",
  "property-translator": "/property-translator/static-1.5514",
  "hs-locale-management": "/hs-locale-management/static-1.168",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8044",
  "hs-promise-utils": "/hs-promise-utils/static-1.5710",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4995",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13950",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5723",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7899",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4593",
  "superstore": "/superstore/static-1.4876",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10368",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8081",
  "hub-http-janus": "/hub-http-janus/static-1.846",
  "hubspotter-http": "/hubspotter-http/static-1.4737",
  "immutable-less": "/immutable-less/static-1.4770",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17572",
  "nav-meta": "/nav-meta/static-1.29942",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18156",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3933",
  "property-management-common": "/property-management-common/static-1.5852",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9184",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.545",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.857",
  "quartz-test": "/quartz-test/static-1.857",
  "quartz-tracking": "/quartz-tracking/static-1.561",
  "trellis-components": "/trellis-components/static-1.2216",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.184",
  "bender-build-tools": "/bender-build-tools/static-1.3297",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21860",
  "ContentUtils": "/ContentUtils/static-1.68713",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13146",
  "sassPrefix": "/sassPrefix/static-1.158",
  "avatar-components": "/avatar-components/static-1.2615",
  "breeze-engine-core": "/breeze-engine-core/static-1.411",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.262",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40211",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13291",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14762",
  "ExportDialog": "/ExportDialog/static-6.10497",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41606",
  "reporting-snowflake": "/reporting-snowflake/static-1.56673",
  "reporting-ui-components": "/reporting-ui-components/static-2.65326",
  "reporting-visualizations": "/reporting-visualizations/static-1.60131",
  "trellis-theming": "/trellis-theming/static-1.1058",
  "ui-addon-teams": "/ui-addon-teams/static-1.21704",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.193",
  "magpie-lib": "/magpie-lib/static-1.5628",
  "navigation-components": "/navigation-components/static-1.18305",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1133",
  "magpie-types": "/magpie-types/static-1.5088",
  "simple-logging-lib": "/simple-logging-lib/static-1.3166",
  "ai-studio-lib": "/ai-studio-lib/static-1.11967",
  "app-governance-lib": "/app-governance-lib/static-1.1930",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10630",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8125",
  "ui-product-approvals": "/ui-product-approvals/static-1.28632",
  "ui-tool-access": "/ui-tool-access/static-1.10266",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9440",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5883",
  "usage-tracker-public": "/usage-tracker-public/static-1.7277",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3673",
  "persist-promise": "/persist-promise/static-1.3817",
  "reference-resolvers": "/reference-resolvers/static-1.8292",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4041",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.454",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3133",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3112",
  "atom": "/atom/static-1.5192",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6097",
  "salesImages": "/salesImages/static-1.527",
  "batch-promise": "/batch-promise/static-1.1660",
  "crm-component-utils": "/crm-component-utils/static-1.39393",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6007",
  "customer-data-properties": "/customer-data-properties/static-1.51977",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7011",
  "property-value-citations": "/property-value-citations/static-1.2591",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8214",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9184",
  "navigation-messaging": "/navigation-messaging/static-1.7632",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10258",
  "base-ui": "/base-ui/static-1.14",
  "react-day-picker": "/react-day-picker/static-1.4",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4932",
  "content-icons-ui": "/content-icons-ui/static-1.2260",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9942",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7364",
  "crm-message-bus": "/crm-message-bus/static-1.43296",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22646",
  "events-data-lib": "/events-data-lib/static-1.350",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4839",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4090",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6916",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1099",
  "onboarding-tours": "/onboarding-tours/static-1.16830",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14022",
  "academy-common-lib": "/academy-common-lib/static-1.14222",
  "content-assistance-lib": "/content-assistance-lib/static-1.7947",
  "dashboard-lib": "/dashboard-lib/static-1.82000",
  "file-manager-components": "/file-manager-components/static-1.23959",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18743",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18583",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18575",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20042",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8821",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4876",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11185",
  "user-context": "/user-context/static-1.5226",
  "growth-payments-core": "/growth-payments-core/static-1.25728",
  "reporting-plugins": "/reporting-plugins/static-1.10510",
  "reporting-reports": "/reporting-reports/static-1.67733",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.843",
  "nest": "/nest/static-1.350",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10744",
  "framework-listing-lib": "/framework-listing-lib/static-2.29029",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30986",
  "apps-service-types": "/apps-service-types/static-1.3917",
  "oauth-service-types": "/oauth-service-types/static-1.4370",
  "react-dnd-compat": "/react-dnd-compat/static-1.4732",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.527",
  "onboarding-scopes": "/onboarding-scopes/static-1.6577",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5044",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7760",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15067",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3672",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9603",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6100",
  "signup-constants": "/signup-constants/static-1.19137",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8174",
  "card-properties-lib": "/card-properties-lib/static-1.44549",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37421",
  "crm-actions": "/crm-actions/static-1.6457",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43945",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9587",
  "customer-data-tracking": "/customer-data-tracking/static-1.7004",
  "hs-resources": "/hs-resources/static-1.292",
  "pulse": "/pulse/static-1.722",
  "calling-global-api": "/calling-global-api/static-1.64920",
  "calling-internal-common": "/calling-internal-common/static-1.31427",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66302",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58596",
  "commerce-products-lib": "/commerce-products-lib/static-1.10006",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3884",
  "crm-links": "/crm-links/static-1.6425",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4223",
  "external-options-client-types": "/external-options-client-types/static-1.4213",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4304",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.750",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3777",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49154",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4052",
  "smart-property-lib": "/smart-property-lib/static-1.7848",
  "tiered-pricing": "/tiered-pricing/static-1.1529",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11107",
  "zustand": "/zustand/static-1.74",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.130",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1173",
  "growth-data-modal": "/growth-data-modal/static-1.5625",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3182",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2260",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.896",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7749",
  "academy-service-client": "/academy-service-client/static-1.3801",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39458",
  "FileManagerLib": "/FileManagerLib/static-1.39599",
  "SafeStorage": "/SafeStorage/static-1.4516",
  "video-embed": "/video-embed/static-1.36152",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28890",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11660",
  "video-data-lib": "/video-data-lib/static-1.35318",
  "content-media-capture": "/content-media-capture/static-1.4876",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "payment-link-components": "/payment-link-components/static-1.23831",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10004",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24639",
  "viral-links-lib": "/viral-links-lib/static-1.7185",
  "data-token-picker": "/data-token-picker/static-1.16624",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.348",
  "timezone-utils": "/timezone-utils/static-2.5360",
  "seat-types-lib": "/seat-types-lib/static-1.280",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17861",
  "ui-addon-opt": "/ui-addon-opt/static-4.8478",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9453",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25691",
  "framework-data-table": "/framework-data-table/static-2.12191",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6982",
  "nudge-client-utils": "/nudge-client-utils/static-1.2837",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1240",
  "switchboard-lib": "/switchboard-lib/static-1.341",
  "app-users-service-client": "/app-users-service-client/static-1.5726",
  "app-users-service-types": "/app-users-service-types/static-1.5134",
  "mini-checkout-client": "/mini-checkout-client/static-1.27099",
  "onboarding-utils": "/onboarding-utils/static-1.5475",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2062",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28875",
  "edison-service-client-types": "/edison-service-client-types/static-1.506",
  "crm_data": "/crm_data/static-4.92342",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46344",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16966",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4377",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1261",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19478",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18833",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10694",
  "crm-fe-perf": "/crm-fe-perf/static-1.23019",
  "event-emitter": "/event-emitter/static-1.1066",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.225",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31434",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11152",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6660",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1449",
  "commerce-permissions": "/commerce-permissions/static-1.893",
  "products-iframe-lib": "/products-iframe-lib/static-1.8261",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10642",
  "data-agent-kit": "/data-agent-kit/static-1.398",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10343",
  "policy-lib": "/policy-lib/static-1.6899",
  "react-tinymce": "/react-tinymce/static-1.55560",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10406",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54686",
  "tinymce-plugins": "/tinymce-plugins/static-1.57800",
  "tinymce-themes": "/tinymce-themes/static-1.56656",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2170",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2288",
  "user-context-client": "/user-context-client/static-1.4697",
  "audio-components": "/audio-components/static-1.6103",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37110",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4653",
  "video-components": "/video-components/static-1.13662",
  "outpost": "/outpost/static-1.4287",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6695",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12680",
  "content-media-compositions": "/content-media-compositions/static-2.16687",
  "media-bridge-lib": "/media-bridge-lib/static-1.19137",
  "fix-webm-duration": "/fix-webm-duration/static-1.24",
  "notification-sounds": "/notification-sounds/static-1.4543",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6322",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5198",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3710",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21890",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3967",
  "ts-utils-lib": "/ts-utils-lib/static-1.291",
  "crm-export-dialog": "/crm-export-dialog/static-1.6402",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6558",
  "crm-view-components": "/crm-view-components/static-1.634",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7448",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2594",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2913",
  "whisper-core-api": "/whisper-core-api/static-1.6875",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15125",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5810",
  "settings-content-modals": "/settings-content-modals/static-1.46418",
  "crm_universal": "/crm_universal/static-1.22224",
  "customer-data-email": "/customer-data-email/static-1.18251",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37515",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39844",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12638",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55116",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21791",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18289",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72416",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5458",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9855",
  "utility-belt": "/utility-belt/static-1.2649",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23267",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7725",
  "customer-data-rte": "/customer-data-rte/static-1.33309",
  "cv-backend-services": "/cv-backend-services/static-1.1559",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5964",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5223",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38506",
  "trials-service-types": "/trials-service-types/static-1.4000",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36226",
  "sales-views-client-types": "/sales-views-client-types/static-1.4374",
  "hub-http-contrib": "/hub-http-contrib/static-1.3160",
  "interframe": "/interframe/static-3.4877",
  "tinymce-data": "/tinymce-data/static-1.40771",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5327",
  "layout-dnd-components": "/layout-dnd-components/static-1.12681",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11656",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15712",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9140",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7722",
  "social-insights-client-types": "/social-insights-client-types/static-1.22352",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4291",
  "checkout-sdk": "/checkout-sdk/static-3.23942",
  "company-details-components": "/company-details-components/static-1.6315",
  "payment-method-components": "/payment-method-components/static-1.6987",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14727",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3582",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3639",
  "access-control-lib": "/access-control-lib/static-1.10553",
  "EmailComponents": "/EmailComponents/static-1.55101",
  "EmailData": "/EmailData/static-1.53778",
  "redux-less": "/redux-less/static-2.9599",
  "sequences-lib": "/sequences-lib/static-1.8246",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10467",
  "products-ui-components": "/products-ui-components/static-1.40524",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7264",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55132",
  "commerce-products-api": "/commerce-products-api/static-1.2469",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57190",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103094",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81137",
  "stripe-connect-js": "/stripe-connect-js/static-1.71",
  "draft-content-plugins": "/draft-content-plugins/static-1.28575",
  "ContentData": "/ContentData/static-1.68788",
  "layout-data-lib": "/layout-data-lib/static-1.9981",
  "checkout-service-types": "/checkout-service-types/static-1.3883",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.812",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4054",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4107",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.674",
  "pricing-pages-api": "/pricing-pages-api/static-1.14592",
  "ContentComponents": "/ContentComponents/static-2.71669",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10438",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1986",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46618",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1480",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19229",
  "automation-ui-types": "/automation-ui-types/static-1.20147",
  "messaging-types-lib": "/messaging-types-lib/static-1.46355",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4621",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8103",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.652",
  "price-books-api": "/price-books-api/static-1.1253",
  "price-books-components": "/price-books-components/static-1.1311",
  "property-description-translator": "/property-description-translator/static-1.3958",
  "ramp-editor": "/ramp-editor/static-1.463",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3698",
  "totals-ui-components": "/totals-ui-components/static-1.23920",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9409",
  "advanced-menus-core": "/advanced-menus-core/static-1.15331",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12242",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34362",
  "segments-query-core": "/segments-query-core/static-1.1537",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6063",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7455",
  "data-token-views": "/data-token-views/static-1.16605",
  "forms-utils-lib": "/forms-utils-lib/static-1.12809",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13278",
  "simple-menus-core": "/simple-menus-core/static-1.15330",
  "simple-menus-lib": "/simple-menus-lib/static-1.16847",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7002",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.15",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7628",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3594",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2632",
  "ContentEditorUI": "/ContentEditorUI/static-2.77434",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4040",
  "web-interactives-components": "/web-interactives-components/static-1.13975",
  "web-interactives-data": "/web-interactives-data/static-1.13976",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.929",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1099",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1094",
  "line-items-api": "/line-items-api/static-1.866",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3904",
  "FireAlarmUi": "/FireAlarmUi/static-1.4594",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4255",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22083",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21546",
  "data-studio-ubb": "/data-studio-ubb/static-1.3066",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27293",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58196",
  "content-management-data-lib": "/content-management-data-lib/static-1.5618",
  "copilot-plugins": "/copilot-plugins/static-1.11412",
  "cta-picker": "/cta-picker/static-1.36713",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3426",
  "editor-components": "/editor-components/static-1.13406",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8573",
  "error-messaging-js": "/error-messaging-js/static-1.5310",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86137",
  "pictos": "/pictos/static-7.186",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10763",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1861",
  "smart-content-core": "/smart-content-core/static-1.42767",
  "smart-content-lib": "/smart-content-lib/static-1.43420",
  "social-composer-lib": "/social-composer-lib/static-1.59576",
  "structured-content-lib": "/structured-content-lib/static-1.25509",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53569",
  "tinymce-copilot": "/tinymce-copilot/static-1.16754",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8059",
  "automation-ui-routing": "/automation-ui-routing/static-1.21504",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5731",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42456",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3310",
  "reporting-enablement": "/reporting-enablement/static-1.23331",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21851",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2993",
  "forms-ai-lib": "/forms-ai-lib/static-1.4508",
  "codemirror-dlb": "/codemirror-dlb/static-1.58993",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6552",
  "report-customization-components": "/report-customization-components/static-1.13498",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13342",
  "reporting-filters": "/reporting-filters/static-1.619",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2094"
}
};
